<template>
    <div>
        <b-card no-body>
            <v-table    ref="table"
                        :items-provider="provider"
                        pagination="server"
                        search
                        name="fuel-price"
                        :fields="fields">
                            <template #additional-actions>
                                <div class="row g-50 fuel-brand-container align-items-center justify-content-center justify-content-md-start w-100 no-gutters">
                                    <div class="col-md-3">
                                        <flat-pickr v-model="mainDateRange" class="form-control" :config="{altInput:true,mode:'range', altFormat:'d.m.Y', dateFormat: 'Y-m-d',locale:'tr'}" placeholder="Tarih Seçiniz"/>
                                    </div>
                                    <div class="col-md-auto col-12 border-md-right pr-md-50">
                                        <button class="btn btn-success w-100" v-on:click="$refs.table.refresh()">
                                            Sorgula
                                        </button>
                                    </div>
                                    <div class="col-auto">
                                        <div v-on:click="changeFuelBrand(null)" class="fuel-brand ALL px-1 py-50 border rounded" :class="currentBrandId == null ? 'active' : null">TÜMÜ</div>
                                    </div>
                                    <div class="col-auto" v-for="(brand,index) in fuelBrandWithPic" :key="index">
                                        <div class="fuel-brand px-75 py-50 border rounded"  v-on:click="changeFuelBrand(brand.Id)" :class="[brand.Id == currentBrandId ? 'active' : null, brand.BrandCode]">
                                            <img :src="brand.Img"/>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template #filters>
                                <price-filter v-on:filter="filter($event)"></price-filter>
                            </template>
                        </v-table>
        </b-card>
        <div class="row align-items-center">
            <div class="col">
                <flat-pickr v-model="dateRange" class="form-control" :config="{altInput:true, altFormat:'d.m.Y',mode:'range', dateFormat: 'Y-m-d',locale:'tr'}" placeholder="Tarih Aralığı Seçiniz"/>
            </div>
            <div class="col-md-auto">
                <button class="btn btn-success w-100" v-on:click="getStats">
                    Sorgula
                </button>
            </div>
        </div>
        <div class="row mt-1">
            <div class="col-md-4">
                <price-avg ref="sub-table-1" :items="avgPrices"></price-avg>
            </div>
            <div class="col-md-4">
                <price-min-and-max ref="sub-table-2" :items="minAndMaxPrices"></price-min-and-max>
            </div>
            <div class="col-md-4">
                <price-square-root ref="sub-table-3" :items="squareRootPrices"></price-square-root>
            </div>
        </div>
    </div>
</template>

<script>
import { BCard,BDropdown } from 'bootstrap-vue'
import FuelOperationApi from '@/api/fuel-operations'
import SystemDataApi from '@/api/system-data'
import PriceSquareRoot from '@/views/fuel/components/PriceSquareRoot.vue'
import PriceAvg from '@/views/fuel/components/PriceAvg.vue'
import PriceFilter from '@/views/fuel/components/PriceFilter.vue'
import PriceMinAndMax from '@/views/fuel/components/PriceMinAndMax.vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/l10n/tr.js' 
import moment from 'moment'
import VDropdown from '@/components/VDropdown.vue'

export default {
    components:{
        BCard,
        PriceSquareRoot,
        PriceAvg,
        PriceMinAndMax,
        flatPickr,
        BDropdown,
        PriceFilter,
        VDropdown
    },
    data(){
        return{
            fuelBrands:[],
            avgPrices:[],
            minAndMaxPrices:[],
            squareRootPrices:[],            
            currentBrandId:null,
            dateRange:null,
            mainDateRange:[moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')].join(' - '),
            fields:[
                {name:"Son Güncellenme",thClass:'w-10',key:"LastUpdatedTimeStr",sortable:true,sortKey:'LastUpdateTime'},
                {name:"Marka",key:"BrandName",sortable:true},
                {name:"İl",key:"ProvinceName",sortable:true},
                {name:"İlçe",key:"DistrictName",sortable:true},
                {
                    name:"Motorin (TL/LT)",
                    children:[
                        {name:"VH",key:"MotorinWithoutTax",tdClass:"text-right text-warning ",sortable:true,sortKey:"Motorin",tooltip:"Vergi Hariç"},
                        {name:"VD",key:"Motorin",tdClass:"text-right text-success font-weight-bolder",sortable:true,tooltip:"Vergi Dahil"},
                    ]
                },
                {
                    name:"Motorin Ultimate (TL/LT)",
                    children:[
                        {name:"VH",key:"MotorinUltimateWithoutTax",tdClass:"text-right text-warning",sortable:true,sortKey:"MotorinUltimate",tooltip:"Vergi Hariç"},
                        {name:"VD",key:"MotorinUltimate",tdClass:"text-right text-success font-weight-bolder",sortable:true,tooltip:"Vergi Dahil"},
                    ]
                },
                {
                    name:"Benzin (TL/LT)",
                    children:[ 
                        {name:"VH",key:"BenzinWithoutTax",tdClass:"text-right text-warning",sortable:true,sortKey:"Benzin",tooltip:"Vergi Hariç"},
                        {name:"VD",key:"Benzin",tdClass:"text-right text-success font-weight-bolder",sortable:true,tooltip:"Vergi Dahil"},
                    ]
                },
                {
                    name:"Benzin Ultimate (TL/LT)",
                    children:[
                        {name:"VH",key:"BenzinUltimateWithoutTax",tdClass:"text-right text-warning",sortable:true,sortKey:"BenzinUltimate",tooltip:"Vergi Hariç"},
                        {name:"VD",key:"BenzinUltimate",tdClass:"text-right text-success font-weight-bolder",sortable:true,tooltip:"Vergi Dahil"}
                    ]
                },
                {
                    name:"LPG (TL/LT)",
                    children:[
                        {name:"VH",key:"LpgWithoutTax",tdClass:"text-right text-warning",sortable:true,sortKey :"Lpg",tooltip:"Vergi Hariç"},
                        {name:"VD",key:"Lpg",tdClass:"text-right text-success font-weight-bolder",sortable:true,tooltip:"Vergi Dahil"},
                    ]
                },
            ],
            showFilter:false,
            filterData:{
                ProvinceId:null,
                DistrictIds:[]
            }
        }
    },
    created(){
        this.dateRange = this.c_month
    },
    mounted(){
        this.getFuelBrands()
        this.getStats()
    },
    methods:{
        filter(filter){
            this.filterData = filter
            this.showFilter = false
            this.$refs.table.refresh()
        },
        provider(data){
            return FuelOperationApi.Table({
                FuelBrandId:this.currentBrandId,
                ...this.c_mainDates,
                PaginationRequestModel:data,
                ProvinceId:this.filterData.ProvinceId || null,
                DistrictIds: this.filterData.DistrictIds?.length ? this.filterData.DistrictIds : null
            })
        },
        getFuelBrands(){
            SystemDataApi.FuelBrand().then(response=>{
                this.fuelBrands = response.data.Data
            })
        },
        changeFuelBrand(id){
            this.currentBrandId = id
            this.$refs.table.refresh()
        },
        getStats(){
            this.$refs["sub-table-1"].setLoading(true)
            this.$refs["sub-table-2"].setLoading(true)
            this.$refs["sub-table-3"].setLoading(true)
            FuelOperationApi.Stats(this.c_dates.StartDate,this.c_dates.EndDate).then(response=>{
                this.avgPrices = response.data.Data.AvgPrices
                this.minAndMaxPrices = response.data.Data.MinAndMaxPrices
                this.squareRootPrices = response.data.Data.SqrtPrices
                this.$refs["sub-table-1"].setLoading(false)
                this.$refs["sub-table-2"].setLoading(false)
                this.$refs["sub-table-3"].setLoading(false)
            }).catch(error=>{
                this.$refs["sub-table-1"].setLoading(false)
                this.$refs["sub-table-2"].setLoading(false)
                this.$refs["sub-table-3"].setLoading(false)
            })
        },
    },
    computed:{
        fuelBrandWithPic(){
            return this.fuelBrands.map(brand=>{
                brand.Img = require('@/assets/images/petrol-brand/'+ brand.BrandCode +'.svg')
                return brand
            })
        },
        c_dates(){
            return {
                StartDate : this.dateRange?.split(' - ')[0] || null,
                EndDate : this.dateRange?.split(' - ')[1] || null
            }
        },
        c_mainDates(){
            return {
                StartDate : this.mainDateRange?.split(' - ')[0] || null,
                EndDate : this.mainDateRange?.split(' - ')[1] || null
            }
        },
        c_month(){
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return [moment(firstDay).format("YYYY-MM-DD"),moment(lastDay).format("YYYY-MM-DD")].join(" - ")
        }
    }
}
</script>

<style>
    .fuel-brand-container .fuel-brand{
        cursor:pointer;
        font-weight: bold;
    }

    .dark-layout .fuel-brand-container .fuel-brand{
        border-color: rgb(75, 82, 103)
    }

    .fuel-brand-container [class*="col-"]:first-child .fuel-brand{
        margin-left: 0px;
    }

    .fuel-brand.ALL.active{
        border-color: var(--primary) !important;
        box-shadow: 0px 0px 0px 1px var(--primary);
        background-color: rgba(31, 70, 144,0.2);
        color:var(--primary);
    }

    .dark-layout .fuel-brand.ALL.active{
        border-color: white !important;
        box-shadow: 0px 0px 0px 1px white;
        background-color: rgba(255, 255, 255,0.2);
        color:white;
    }

    .fuel-brand.PO.active{
        border-color: rgb(235, 25, 35) !important;
        box-shadow: 0px 0px 0px 1px rgb(235, 25, 35);
        background-color: rgb(235, 25, 35,0.2);
    }

    .fuel-brand.OPET.active{
        border-color: rgb(0, 124, 195) !important;
        box-shadow: 0px 0px 0px 1px rgb(0, 124, 195);
        background-color: rgba(0, 124, 195,0.2);
    }

    .fuel-brand.BP.active{
        border-color: rgb(51, 164, 87) !important;
        box-shadow: 0px 0px 0px 1px rgb(51, 164, 87);
        background-color: rgba(51, 164, 87,0.2);
    }
    
    .fuel-brand.TOTAL.active{
        border-color: rgb(228, 3, 46) !important;
        box-shadow: 0px 0px 0px 1px rgb(228, 3, 46);
        background-color: rgba(228, 3, 46,0.2);
    }

    .fuel-brand img{
        height: 20px;
        width: auto;
    }

    .fuel-brand-img-stats{
        height: 20px;
        width: auto;
    }

    @media (min-width: 768px){
        .border-md-right{
            border-right: 1px solid #ebe9f1 !important;
        }
    }
</style>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>